import { IUtilityTrayOptions } from "@opengov/components-nav-bar";
import { IntlShape } from "react-intl";

import { GlobalNavApplicationId } from "../types";

export type GetNewActionOptionsParams = {
  intl: IntlShape;
  isUserFormSubmitter: boolean;
  isFormAndWorkflowsFeatureEnabled: boolean | undefined;
  isPerformanceManagementFeatureEnabled: boolean | undefined;
  isPerformanceLimitedFeaturesEnabled: boolean | undefined;
  activeAppKey: GlobalNavApplicationId;
  onCreateRequest: () => void;
  onCreateKpiSubmission: () => void;
};

const PERFORMANCE_MANAGEMENT_RELATED_APPS = ["performance", "performancePublicServicePlatform"];
const WORKFLOWS_RELATED_APPS = ["workflows"];

export const getNewActionOptions = ({
  intl,
  isUserFormSubmitter,
  isFormAndWorkflowsFeatureEnabled,
  isPerformanceManagementFeatureEnabled,
  isPerformanceLimitedFeaturesEnabled,
  activeAppKey,
  onCreateRequest,
  onCreateKpiSubmission,
}: GetNewActionOptionsParams) => {
  if (!isUserFormSubmitter) return undefined;
  const newActionOptions: IUtilityTrayOptions["createNewActionOptions"] = [];
  if (isFormAndWorkflowsFeatureEnabled && !PERFORMANCE_MANAGEMENT_RELATED_APPS.includes(activeAppKey)) {
    newActionOptions.push({
      label: intl.formatMessage({ defaultMessage: "Create Request" }),
      dataOg: "new_request",
      handleCreate: onCreateRequest,
    });
  }
  if (
    isPerformanceManagementFeatureEnabled &&
    !isPerformanceLimitedFeaturesEnabled &&
    !WORKFLOWS_RELATED_APPS.includes(activeAppKey)
  ) {
    newActionOptions.push({
      label: intl.formatMessage({ defaultMessage: "Submit Metrics" }),
      dataOg: "new_performance_kpi",
      handleCreate: onCreateKpiSubmission,
    });
  }
  return newActionOptions.length > 0 ? newActionOptions : undefined;
};
